import { useMemo } from 'react';
import { Drawer } from '@cad-arc';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { PatrolDrawerContent } from './patrol-drawer-content';

export const VirtualPatrolDrawer = function VirtualPatrolDrawer({
    unitId,
    statusId,
}: {
    unitId?: number;
    statusId?: number;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const closeDrawer = useMemo(
        () => () => {
            drawerControls.close();
        },
        [drawerControls]
    );
    return (
        <Drawer variant="overlay" isOpen={true} size="lg" onClose={closeDrawer}>
            <PatrolDrawerContent
                header="Virtual Patrol"
                attributeType="VIRTUAL_PATROL"
                unitId={unitId}
                statusId={statusId}
                closeDrawer={closeDrawer}
            />
        </Drawer>
    );
};

type VirtualPatrolDrawerType = typeof VirtualPatrolDrawer;
export type { VirtualPatrolDrawerType };
